import {
    RESGATES_PENDENTES_LOAD,
    RESGATES_PENDENTES_SUCCESS,
    RESGATES_PENDENTES_ERROR,
} from '../actionTypes'

const initialState = {
    isLoading: false,
    resgates: [],
}

export default (state = initialState, action) => {
    switch(action.type) {
        
        case RESGATES_PENDENTES_LOAD:
            return {
                ...state,
                isLoading: true
            }

        case RESGATES_PENDENTES_SUCCESS:
            return {
                ...state,
                resgates: action.payload.resgates,
                isLoading: false,
            }

        case RESGATES_PENDENTES_ERROR:
            return {
                ...state,
                isLoading: false,
                aportes: []
            }
            
        default:
            return state
    }
}